import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, ChangeDetectorRef, forwardRef } from "@angular/core";
import {
    CclNavbarSecondaryService,
    CclList,
    CclListColumn,
    CclTemplateResolverService,
    CclListTemplateProviderComponent,
    CclListTemplates,
    CclListColumnSize,
    CclMessageService,
    CclNavbarFooterService,
    CclDrawerService
} from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { cloneDeep, isEqual } from "lodash";
import { SessionService } from "../../../../../modules/shared/services/session-service";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { Subscription } from "rxjs";
import { FlashMessagesService } from "angular2-flash-messages";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-highlighted-page",
    templateUrl: "./highlighted-page.view.html",
    styleUrls: []
})
export class HighlightedPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    @ViewChild("tempSpeakerList")
    tempSpeakerList: any;

    columns: CclListColumn[];
    subscription: Subscription;

    speakerConfigObj: any;
    speakerDataConfig: any = {};

    displayAs: any = [
        {
            label: "One Speaker at a time in an Automatic Carousel",
            code: "1_carousel"
        },
        {
            label: "All Speakers as List",
            code: "all_session"
        }
    ];

    displayAsHighlighted: any = [
        {
            label: "All Speakers as List",
            code: "all_session"
        }
    ];

    speakerConfig = {
        eventId: this.sharedService.event.id,
        speakerName: "",
        organization: "",
        speakerType: -1,
        speakerTypeIds: [],
        limit: 10,
        page: 0,
        field: "[profile].pro_fname",
        order: "asc"
    };

    sortCase;

    speakers: CclList = <CclList>{};
    selectedSessions: CclList = <CclList>{};
    baseUrl: string;

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private templateResolver: CclTemplateResolverService,
        private cdRef: ChangeDetectorRef,
        private sessionService: SessionService,
        private catalogService: CatalogService,
        private messageService: CclMessageService,
        private navbarFooterService: CclNavbarFooterService,
        private _flashMessagesService: FlashMessagesService,
        private drawerService: CclDrawerService
    ) {
        super(sharedService);
        this.navSecondaryService.sectionLabel = "Data";
        this.baseUrl = "highlighted";
        // if (this.activatedRoute.routeConfig.path === "highlighted") {
        //     this.baseUrl = "highlighted";
        // }
        this.sharedService.sessionUrl = this.baseUrl;
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveSessionConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.speakerDataConfig = cloneDeep(this.sharedService.dataConfig[this.baseUrl]);
        this.speakerConfigObj = this.sharedService.configs[this.sharedService.configTypes.DATA[this.baseUrl]];

        if (this.speakerConfigObj == null || this.speakerConfigObj.id == null) {
            this.speakerConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.DATA[this.baseUrl]
            };
        } else {
            this.speakerDataConfig = JSON.parse(this.speakerConfigObj.config);
        }

        if (this.speakerDataConfig.selectedList != null && this.speakerDataConfig.selectedList.length > 0) {
            this.fetchSpeakers();
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.speakerDataConfig);
        this.sharedService.changedData = this.speakerDataConfig;
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    ngAfterViewInit(): void {
        const listTemplates = this.templateResolver.getTemplates(CclListTemplateProviderComponent, [
            CclListTemplates.icon,
            CclListTemplates.name,
            CclListTemplates.data,
            CclListTemplates.actionIcons
        ]);
        this.columns = [
            {
                label: "Speaker Name",
                template: listTemplates[CclListTemplates.name],
                size: CclListColumnSize.full,
                key: "fullName"
            },
            {
                label: "Organization",
                template: listTemplates[CclListTemplates.data],
                size: CclListColumnSize.lg,
                key: "organization"
            },
            {
                label: "Actions",
                template: listTemplates[CclListTemplates.actionIcons],
                size: CclListColumnSize.xs,
                key: "",
                templateConfig: {
                    icons: [
                        {
                            class: "fa-times action-icon-danger",
                            clickFn: this.deleteSession.bind(this),
                            title: "Delete Speaker"
                        }
                    ]
                }
            }
        ];

        this.cdRef.detectChanges();

        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (this.sharedService.sessionUrl == "highlighted") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Data for general section";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-data-session";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-data-next-session";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    deleteSession(e) {
        let removeIndex = this.speakerDataConfig.selectedList.indexOf(e.id);
        if (removeIndex >= 0) {
            this.speakerDataConfig.selectedList.splice(removeIndex, 1);
        }
        if (this.selectedSessions.data != null) {
            this.selectedSessions.data.forEach((element, index) => {
                if (element["id"] == e.id) {
                    this.selectedSessions.data.splice(index, 1);
                }
            });
        }
    }

    paginationFilter: any = {
        limit: 100,
        total: 0,
        count: 0,
        offset: 1
    };

    loadFilteredSessions(ev) {
        let event = cloneDeep(ev);
        this.speakerConfig.order = "asc";
        if (event.sortDescending) {
            this.speakerConfig.order = "desc";
        }
        if (event.sortProperty != null && event.sortProperty != "") {
            if (event.sortProperty === "fullName") {
                this.speakerConfig.field = "[profile].pro_fname";
            } else {
                this.speakerConfig.field = "[" + event.sortProperty + "]";
            }
        }

        this.fetchSpeakers();
    }

    fetchSpeakers() {
        if (this.speakerDataConfig.selectedList != null && this.speakerDataConfig.selectedList.length > 0) {
            let selectedSpeakerFilter = {
                eventId: this.sharedService.event.id,
                limit: 20,
                page: 0,
                field: this.speakerConfig.field,
                order: this.speakerConfig.order,
                active: true,
                speakerIds: this.speakerDataConfig.selectedList
            };
            this.sessionService.speakerList(selectedSpeakerFilter).subscribe((data) => {
                if (data.body != null && data.body['data'].length > 0) {
                    var selectedSpeakerList = [];
                    this.selectedSessions = <CclList>data.body;
                    this.selectedSessions.data.forEach((element) => {
                        element["fullName"] = element["firstName"] + " " + element["lastName"];
                        selectedSpeakerList.push(element["id"]);
                    });
                    if(!isEqual(this.speakerDataConfig.selectedList,selectedSpeakerList)) {
                        let temp = this.selectedSessions.data;
                        this.selectedSessions = <CclList>{ data: [] };
                        this.speakerDataConfig.selectedList.forEach(element => {
                           let obj = temp.find((o:any) => o.id === element);
                           this.selectedSessions.data.push(obj);
                        });
                    }

                    if (this.speakerDataConfig.selectedList.length > selectedSpeakerList.length) {
                        this.speakerDataConfig.selectedList = selectedSpeakerList;
                    }
                    this.selectedSessions.pagination = null;
                } else if (data.body != null && data.body['data'].length == 0 && this.speakerDataConfig.selectedList.length > 0) {
                    this.speakerDataConfig.selectedList = [];
                }
            });
        } else {
            this.selectedSessions = <CclList>{ data: [] };
            this.selectedSessions.data = [];
            this.speakerDataConfig.selectedList = [];
            this.selectedSessions.pagination = null;
        }
    }

    openDrawer($event) {
        $event.stopPropagation();
        this.sharedService.sessionUrl = this.baseUrl;
        this.sharedService.dataConfig[this.baseUrl] = cloneDeep(this.speakerDataConfig);
        this.drawerService.toggleDrawer("large");
        this.sharedService.currentDrawer = {
            title: "Select Another Speaker",
            navLinks: null,
            saveMessage: "refresh-data-session-list"
        };
        let url = "config-drawer/speaker-sessions/session-config";
        this.sharedService.navigateToOutlet("drawer", url);
    }

    saveSessionConfig(message) {
        if (message.text == "save-data-session" || message.text == "save-data-next-session") {
            if (this.selectedSessions.data != null) {
                if (this.selectedSessions.data.length >= 0) {
                    this.speakerDataConfig.selectedList = [];
                    this.selectedSessions.data.forEach((element) => {
                        this.speakerDataConfig.selectedList.push(element["id"]);
                    });
                }
            } else {
                this.speakerDataConfig.selectedList = [];
            }

            if (this.speakerDataConfig.selectedList.length > 20) {
                this._flashMessagesService.show(
                    "Cannot select more than 20 speakers for " + this.sharedService.toCamelCase(this.baseUrl),
                    {
                        cssClass: "alert-danger"
                    }
                );
                return false;
            }
            this.speakerConfigObj.config = JSON.stringify(this.speakerDataConfig);
            this.catalogService.saveSetupConfig(this.speakerConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.originalData = cloneDeep(this.speakerDataConfig);
                this.sharedService.changedData = this.speakerDataConfig;

                this.speakerConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[this.sharedService.configTypes.DATA[this.baseUrl]] = this.speakerConfigObj;
                this._flashMessagesService.show("Featured data speaker layout is saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-data-next-session") {
                    this.sharedService.currentLayoutSection = "";
                    this.sharedService.catalogNavigateHelper("admin", "catalog/data/general");
                }
            });
        }
        if (message.text === "refresh-data-session-list") {
            this.speakerDataConfig = cloneDeep(this.sharedService.dataConfig[this.baseUrl]);
            this.sharedService.changedData = this.speakerDataConfig;
            this.drawerService.hideDrawer();
            this.fetchSpeakers();
        }
    }
}
